<template>
  <div class="pages">
    <shortcut-bar class="shortcut-bar page-header" />
    <div class="page-header-placeholder"></div>

    <div class="content_box">
      <!-- 地址 -->
      <div class="goods_box">
        <p class="left_title">{{ $t('商品信息') }}</p>
        <div v-for="(item, index) in items">
          <p class="goods_title">
            {{ item.product_title }}
          </p>
          <p class="align-center">
            <span class="text-999 text-16">{{ $t('订单金额') }}</span>
            <span class="price"><span class="text-14">￥</span>{{ item.pay_price }}</span>
          </p>
        </div>
      </div>
      <div class="total">
        <div class="text-999 text-16">{{ $t('订单总金额') }}</div>
        <div class="total-price"><span class="text-14">￥</span>{{ total_price.toFixed(2) }}</div>
      </div>
      <!-- 下单信息 -->
      <div class="margin-top-32">
        <p class="left_title">{{ $t('确认支付方式') }}</p>
        <!-- <div class="radio_box">
          <el-radio v-model="radio" label="1" style="display: flex;align-items: center;">
            <div style="display: flex;align-items: center;">
              <img src="../../../static/images/icon/icon37.png" alt="" class="pay-icon">
              <p style="margin-left: 12px;">{{ $t('微信支付') }}</p>
            </div>
          </el-radio>
          <el-radio v-model="radio" label="2" style="display: flex;align-items: center;">
            <div style="display: flex;align-items: center;">
              <img src="../../../static/images/icon/icon36.png" alt="" class="pay-icon">
              <p style="margin-left: 12px;">{{ $t('支付宝支付') }}</p>
            </div>
          </el-radio>
        </div> -->

        <div class="pay-list">
          <div class="pay-list-box" :class="radio == 1 ? 'pay-list-shadow' : ''" @click="radio = 1">
            <img src="../../../static/images/icon/icon46.png" alt="" class="pay-icon" v-if="radio == 1">
            <img src="../../../static/images/icon/icon45.png" alt="" class="pay-icon" v-else>
            <div>{{$t('微信支付')}}</div>
          </div>
          <div class="pay-list-box" :class="radio == 2 ? 'pay-list-shadow' : ''" @click="radio = 2">
            <img src="../../../static/images/icon/icon48.png" alt="" class="pay-icon" v-if="radio == 2">
            <img src="../../../static/images/icon/icon47.png" alt="" class="pay-icon" v-else>
            <div>{{$t('支付宝支付')}}</div>
          </div>
        </div>

        <div class="add_btn" @click="placeOrder">{{ $t('确认支付') }}</div>
      </div>
    </div>

    <!-- 支付成功弹窗 -->
    <transition name="place-pop">
      <div class="succeedPop" v-if="succeed_show">
        <div class="succeedPop-box flex flex-direction align-center">
          <img src="../../../static/images/icon/icon19.png" alt="" class="box-img">
          <div class="text-20 margin-top-12 margin-bottom-24">{{ $t('购买成功') }}</div>
          <div class="text-16 margin-bottom-8">{{ $t('订单编号：') }}{{ order_sn }}</div>
          <div class="text-16 margin-bottom-8">{{ $t('支付方式：') }}{{ radio == 1 ? '微信支付' : radio == 2 ? '支付宝' : '余额支付' }}
          </div>
          <div class="text-16 margin-bottom-24">{{ $t('支付时间：') }}{{ orderTime }}</div>
          <div class="align-center succeedPop-box-btn">
            <div class="box-btn-l pointer" @click="myOrder">{{ $t('查看订单') }}</div>
            <div class="box-btn-r pointer" @click="onReturn">{{ $t('返回') }}</div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 微信支付二维码弹窗（PC 端扫码支付） -->
    <el-dialog title="微信支付" :visible.sync="wechat_show" width="400px" custom-class="place-order-dialog"
      :before-close="handleClose" @close="stopPaymentStatusPolling">
      <div class="wechat-pay-dialog">
        <img v-if="wechat_qrcode" :src="wechat_qrcode" alt="微信支付二维码" class="wechat-pay-qrcode">
        <p>{{$t('请使用微信扫一扫完成支付')}}</p>
        <p class="wechat-pay-order">订单号：{{ wechat_order_sn }}</p>
      </div>
    </el-dialog>
    <!-- 左侧悬浮框 -->
    <div class="pc-float">
      <leftSuspension />
    </div>

    <footer-bar></footer-bar>
  </div>
</template>

<script>
  import ShortcutBar from "@/components/ShortcutBar";
  import leftSuspension from "@/components/leftSuspension.vue";
  import { orderDetail, balancePayment, AlipayOrder, WeChatOrder } from '@/api/user';
  import QRCode from 'qrcode';
  import footerBar from '@/components/footerBar';

  export default {
    name: "placeOrder",
    components: {
      'footer-bar': footerBar,
      "shortcut-bar": ShortcutBar,
      leftSuspension,
    },
    data() {
      return {
        orderNum: 1,
        remark: "",
        formLabelWidth: "120px",
        checked: false,
        radio: null,//当前选择的支付方式
        succeed_show: false,//支付成功弹窗
        items: [],//商品列表
        total_price: 0,//订单总价
        // payment_data: {},//支付信息
        order_sn: '',//订单号
        orderTime: '',//支付时间
        order_id: '',//订单ID
        wechat_show: false,//微信支付二维码弹窗
        wechat_qrcode: '',//微信支付二维码图片
        wechat_order_sn: '',//微信支付订单号
        payment_status_timer: null//支付状态查询定时器
      };
    },
    mounted() {
      let order_data = JSON.parse(decodeURIComponent(this.$route.params.order));
      this.order_id = order_data.id
      this.onOrderDetail(order_data.id)
      this.order_sn = order_data.order_sn
      // console.log(order_data);
    },
    beforeDestroy() {
      this.stopPaymentStatusPolling();
    },
    methods: {
      async handlePayment() {
        // 生成二维码
      },
      /**返回 */
      onReturn() {
        this.$router.go(-1)
      },
      /**我的订单 */
      myOrder() {
        this.$router.push({ name: 'MyOrder2', params: { type: 0 } });
      },
      /**订单详情 */
      onOrderDetail(id) {
        orderDetail({ id: id }).then(res => {
          // console.log(res.data.items);
          let total_price = 0
          this.items = res.data.items
          this.items.forEach(e => {
            total_price = total_price + Number(e.pay_price)
          })
          this.total_price = total_price
        })
      },
      /**微信支付 */
      WeChatPayment() {
        WeChatOrder({ order_sn: this.order_sn }).then(async res => {
          if (res.code != 1 || !res.data || !res.data.code_url) {
            this.$message.warning(res.msg || '获取微信支付信息失败');
            return;
          }

          const codeUrl = res.data.code_url;
          this.wechat_order_sn = res.data.out_trade_no || this.order_sn;
          this.startPaymentStatusPolling();
          if (this.isMobile()) {
            // H5 端通过 weixin:// 协议唤起微信客户端支付
            window.location.href = codeUrl;
            return;
          }

          try {
            // PC 端将微信支付链接生成二维码，供微信扫一扫支付
            this.wechat_qrcode = await QRCode.toDataURL(codeUrl, {
              width: 260,
              margin: 1,
              errorCorrectionLevel: 'M'
            });
            this.wechat_show = true;
          } catch (error) {
            this.$message.error('生成微信支付二维码失败，请稍后重试');
          }
        }).catch(() => {
          this.$message.error('获取微信支付信息失败，请稍后重试');
        });
      },
      /**是否为移动端浏览器 */
      isMobile() {
        return /Android|webOS|iPhone|iPod|BlackBerry|iPad|Windows Phone/i.test(navigator.userAgent);
      },
      /**开始查询支付状态 */
      startPaymentStatusPolling() {
        this.stopPaymentStatusPolling();
        this.checkPaymentStatus();
        this.payment_status_timer = setInterval(() => {
          this.checkPaymentStatus();
        }, 2000);
      },
      /**停止查询支付状态 */
      stopPaymentStatusPolling() {
        if (this.payment_status_timer) {
          clearInterval(this.payment_status_timer);
          this.payment_status_timer = null;
        }
      },
      /**查询订单是否已支付 */
      checkPaymentStatus() {
        if (!this.order_id) {
          return;
        }
        orderDetail({ id: this.order_id }).then(res => {
          const orderData = res.data || {};
          if (Number(orderData.status) >= 1) {
            this.stopPaymentStatusPolling();
            this.wechat_show = false;
            this.orderTime = orderData.pay_time_text || this.formatPaymentTime(orderData.pay_time);
            this.succeed_show = true;
          }
        });
      },
      /**格式化接口返回的支付时间 */
      formatPaymentTime(time) {
        if (!time) {
          return '';
        }
        const date = new Date(Number(time) * 1000);
        if (isNaN(date.getTime())) {
          return '';
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      /**支付宝弹窗关闭 */
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => { });
      },
      /**支付宝支付 */
      AlipayPayment() {
        // 必须在点击事件中预先打开窗口，否则接口返回后会被浏览器拦截为弹窗。
        const paymentWindow = window.open('', '_blank', 'width=960,height=720,resizable=yes,scrollbars=yes');
        if (!paymentWindow) {
          this.$message.warning('支付窗口被浏览器拦截，请允许弹窗后重试');
          return;
        }

        AlipayOrder({ order_sn: this.order_sn }).then(res => {
          if (res.code == 1) {
            try {
              // 支付宝返回的是可自动提交的表单 HTML，必须运行在顶层窗口，不能写入 iframe。
              paymentWindow.document.open();
              paymentWindow.document.write(res.data);
              paymentWindow.document.close();
              this.startPaymentStatusPolling();
            } catch (error) {
              paymentWindow.close();
              this.$message.error('打开支付宝支付页面失败，请稍后重试');
            }
          } else {
            paymentWindow.close();
            this.$message.warning(res.msg);
          }
        }).catch(() => {
          paymentWindow.close();
          this.$message.error('获取支付宝支付信息失败，请稍后重试');
        });
      },
      /**余额支付 */
      balancePayment() {
        let data = {
          pay_password: '123456',
          order_sn: this.order_sn
        }
        // console.log(data);
        balancePayment(data).then(res => {
          // console.log(res);
          if (res.code == 1) {
            this.$message.success(this.$t('支付成功'));
            // 将时间戳转换为日期对象
            let date = new Date(res.time * 1000);
            // 获取年月日
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            this.orderTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
            this.succeed_show = true
          }
        })
      },
      /**确认支付 */
      placeOrder() {
        /**
         * radio 1为微信  2为支付宝
         */
        if (!this.radio) {
          this.$message.warning('请选择支付方式');
        } else if (this.radio == 1) {
          this.WeChatPayment()
        } else if (this.radio == 2) {
          this.AlipayPayment()
        } else if (this.radio == 3) {
          this.balancePayment()
        }
        // this.$router.push({ name: "orders", params: { id: 1 } });
      },
    },
  };
</script>

<style scoped lang="scss">
  .page-header {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }

  .page-header-placeholder {
    height: 56px;
  }

  .pages {
    box-sizing: border-box;
  }

  .content_box {
    /* // padding: 24px 320px 0; */
    padding: 32px 32px 60px;
    margin: 24px 320px 200px;
    /* // min-height: 80vh; */
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
    border-radius: 8px;

    .left_title {
      color: #333;
      font-size: 18px;
    }

    .goods_title {
      color: #333;
      font-size: 18px;
      margin: 12px 0 8px;
    }

    .goods_box {
      /* // width: 1280px; */
      width: 100%;
      background: #ffffff;
      padding-bottom: 10px;
    }

    .add_btn {
      width: 160px;
      height: 48px;
      background: #000000;
      border-radius: 8px;
      color: #FFFFFF;
      font-size: 16px;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
    }

    .radio_box {
      display: flex;
      flex-direction: column;
      margin: 24px 0;

      .el-radio {
        margin-bottom: 12px;
      }
    }

    .price {
      color: #85674B;
      font-size: 28px;
      margin-left: 8px;
    }
  }

  /**支付成功弹窗 */
  .succeedPop {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    /* background-color: rgba($color: #000000, $alpha: 0.5); */
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    .succeedPop-box {
      width: 400px;
      padding: 40px 0;
      background: #FFFFFF;
      border-radius: 8px;

      .box-img {
        width: 140px;
        height: 100px;
      }

      .succeedPop-box-btn {
        div {
          width: 120px;
          height: 35px;
          box-sizing: border-box;
          border-radius: 8px;
          font-size: 14px;
          text-align: center;
          line-height: 35px;
        }

        .box-btn-l {
          background: #FFFFFF;
          border: 1px solid #999999;
          color: #333333;
          margin-right: 32px;
        }

        .box-btn-r {
          background: #000000;
          color: #FFFFFF;
          margin-left: 32px;
        }
      }
    }
  }

  .total {
    display: flex;
    align-items: center;
    justify-content: end;
    padding-bottom: 32px;
    border-bottom: 1px solid #CCCCCC;

    .total-price {
      color: #85674B;
      font-size: 28px;
      margin-left: 8px;
    }
  }

  .pay-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
  }

  .pay-list {
    display: flex;
    align-items: center;
    margin: 16px 0 65px;

    .pay-list-box {
      display: flex;
      align-items: center;
      padding: 17px 30px;
      border-radius: 8px;
      border: 1px solid #000000;
      margin-right: 48px;
      font-size: 20px;
      cursor: pointer;

      img {
        width: 30px;
        height: 30px;
        margin-right: 16px;
      }
    }

    .pay-list-shadow {
      box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: 767px) {
    .pages {
      overflow-x: hidden;
      width: 100%;
    }

    .page-header {
      padding-top: env(safe-area-inset-top, 0px);
    }

    .page-header-placeholder {
      height: calc(56px + env(safe-area-inset-top, 0px));
    }

    .pc-float {
      display: none;
    }

    .content_box {
      margin: 12px 16px 24px;
      padding: 16px 12px 24px;
      box-sizing: border-box;

      .left_title,
      .goods_title {
        font-size: 16px;
      }

      .price {
        font-size: 22px;
      }

      .add_btn {
        width: 100%;
      }
    }

    .total {
      padding-bottom: 20px;
      flex-wrap: wrap;

      .total-price {
        font-size: 22px;
      }
    }

    .pay-list {
      flex-direction: column;
      align-items: stretch;
      margin: 16px 0 24px;

      .pay-list-box {
        margin-right: 0;
        margin-bottom: 12px;
        justify-content: center;
        font-size: 16px;
        padding: 14px 16px;
        box-sizing: border-box;
      }
    }

    .succeedPop .succeedPop-box {
      width: calc(100vw - 32px);
      max-width: 100%;
      padding: 32px 16px;
      box-sizing: border-box;

      .succeedPop-box-btn {
        width: 100%;
        justify-content: space-between;

        .box-btn-l,
        .box-btn-r {
          margin: 0;
          flex: 1;
        }

        .box-btn-l {
          margin-right: 12px;
        }
      }
    }

    @keyframes place-fade-up {
      from {
        opacity: 0;
        transform: translateY(16px);
      }

      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .content_box {
      animation: place-fade-up 0.4s ease both;
    }

    .content_box .goods_box {
      animation: place-fade-up 0.4s ease both;
    }

    .total {
      animation: place-fade-up 0.4s ease 0.06s both;
    }

    .content_box .margin-top-32 {
      animation: place-fade-up 0.45s ease 0.12s both;
    }

    .pay-list .pay-list-box {
      transition: box-shadow 0.25s ease, transform 0.2s ease, background-color 0.25s ease;
    }

    .pay-list .pay-list-box:active {
      transform: scale(0.98);
    }

    .pay-list .pay-list-shadow {
      transform: translateY(-1px);
    }

    .content_box .add_btn {
      transition: transform 0.15s ease, opacity 0.15s ease;
    }

    .content_box .add_btn:active {
      transform: scale(0.98);
      opacity: 0.88;
    }
  }

  .place-pop-enter-active,
  .place-pop-leave-active {
    transition: opacity 0.28s ease;
  }

  .place-pop-enter-active .succeedPop-box,
  .place-pop-leave-active .succeedPop-box {
    transition: transform 0.28s ease;
  }

  .place-pop-enter,
  .place-pop-leave-to {
    opacity: 0;
  }

  .place-pop-enter .succeedPop-box,
  .place-pop-leave-to .succeedPop-box {
    transform: translateY(20px) scale(0.96);
  }
</style>

<style lang="scss">
  .wechat-pay-dialog {
    text-align: center;

    .wechat-pay-qrcode {
      display: block;
      width: 260px;
      height: 260px;
      margin: 0 auto 16px;
    }

    .wechat-pay-order {
      margin: 8px 0 0;
      color: #999999;
      font-size: 13px;
      word-break: break-all;
    }
  }

  @media (max-width: 767px) {
    .place-order-dialog {
      width: calc(100vw - 32px) !important;
      margin-top: 8vh !important;

      .el-dialog__body {
        padding: 10px;
      }

      iframe {
        width: 100% !important;
        max-width: 300px;
        height: 420px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/order/placeOrder.vue